export default __webpack_public_path__ + "static/media/insuranceservice.c785afda.png";